//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpColumn',
  props: {
    tight: { type: Boolean, default: false },
    highlight: { type: Boolean, default: false },
  },
};
